var _style, _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8EFF9;}\n\t.st1{fill:none;}\n\t.st2{fill:#55BDCA;}\n\t.st3{font-family:'BrushScriptMT';}\n\t.st4{font-size:48px;}\n\t.st5{font-size:12px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,0h52.6C61.5,0,64,2.5,64,5.7v52.6c0,3.1-2.5,5.7-5.7,5.7H5.7C2.5,64,0,61.5,0,58.3V5.7C0,2.5,2.5,0,5.7,0z "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.7,
    y: 4.5,
    className: "st1",
    width: 42.5,
    height: 38.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 25.5647 60.2697)",
    className: "st2 st3 st4"
  }, "W")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2.7229 32.1597)",
    className: "st2 st3 st4"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2.7229 60.9185)",
    className: "st2 st3 st5"
  }, "&lt;3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.9844a1ef23bce465ce9ec806b24747e4.svg";
export { ForwardRef as ReactComponent };